module.exports = __webpack_public_path__ + "img/product.0f13c422.png";